// removed by extract-text-webpack-plugin
module.exports = {"block":"_11p-YQ8no6eCpERzryRW0R","container":"_3pw_yrFp0ecgzfS7z6TUln","heading":"_232c8PbqRvN8xypTmyCqz5","shortcuts":"_1_1Sz7wQjXOCJtQFcK3YgS","shortcut":"_37gMEaBs3O_5QpobCiHEqa","shortcutLink":"_2K-clJnVWc3CwZ0nLPOpPt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShortcutsBlock/ShortcutsBlock.module.scss
// module id = 807
// module chunks = 0